module.exports = __webpack_public_path__ + "static/media/Moon.1e2ee0b5.svg";